import React from 'react';
import parse from 'html-react-parser';
import './style.css';


export const PrivacyAndTerms = ({ heading, text }) => {
  return (
    <div className ="popprivacyPolicy">
      <h2>{heading}</h2>
      <p className='privacyAndTerms'>{parse(text)}</p>
    </div>
  );
};




// WEBPACK FOOTER //
// ./src/components/PrivacyAndTerms/PrivacyAndTerms.js